import { ObjectValues } from 'types';

export type Option = {
  value: string;
  label: string;
};

export const ALIGNMENT = {
  HORIZONTAL: 'horizontal',
  VERTICAL: 'vertical',
} as const;

export type Alignment = ObjectValues<typeof ALIGNMENT>;
